import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/charts/hooks/use-scale.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
